<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-select
                        label="Classificação"
                        v-model="model.classificacaoId"
                        text-field="descricao"
                        value-field="id"
                        :validations="validations.classificacao"
                        :options="form.classificacoes"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        :options="form.subclassificacoes"
                        :validations="validations.subclassificacao"
                        @change="handleSubclassificacaoChange"
                        label="Subclassificação"
                        show-default-option
                        text-field="descricao"
                        v-model="model.subclassificacaoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-date-picker
                        :disabled="enums.subclassificacao.TEMPORARIO !== model.subclassificacaoId"
                        :range-inline="false"
                        end-label="Até"
                        range
                        right
                        start-label="Válido de"
                        v-model="model.periodoValidade"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        label="Prontuário municipal"
                        v-model="form.prontuario"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Prontuário da unidade"
                        v-model="model.prontuarioUnidade"
                        :validations="validations.prontuarioUnidade"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Unidade de referência"
                        v-model="model.unidadeId"
                        :validations="validations.unidadeReferencia"
                        :options="form.unidadesReferencia"
                        text-field="nomeFantasia"
                        value-field="id"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        :options="form.bloqueado"
                        label="Cadastro bloqueado"
                        text-field="text"
                        v-model="model.bloqueado"
                        value-field="value"
                        :disabled="!form.isPermissaoBloquear"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <ListPaciente
            v-if="model.prontuariosUnidades"
            :items="model.prontuariosUnidades"
        />
    </div>
</template>

<script>
// Components.
import ListPaciente from './ListPaciente'

// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { ListPaciente },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    data: () => ({
        enums: {
            classificacao,
            subclassificacao,
        },
    }),
    computed: {
        ...mapGetters({ cliente: 'getCliente' }),
        validations() {

            return {
                classificacao: { required: true },
                subclassificacao: {},
                prontuarioUnidade: { max: 10 },
                unidadeReferencia: { required: true },
            }
        }
    },
    watch: {
        'model.classificacaoId': function (currentId, previousId) {

            this.$emit('select-classificacao', currentId)

            if (this.form.exibeConfirmacaoClassificacao
                && currentId
                && currentId !== previousId
            ) {

                this.showConfirmation(
                    this.getMessageClassificacao(currentId),
                    async () => {},
                    async () => this.model.classificacaoId = previousId
                )
            }
        }
    },
    methods: {
        validate() {

            return this.$refs.Form.validate()
        },
        getMessageClassificacao(id) {

            let message = ''

            switch (id) {

                case this.enums.classificacao.MUNICIPE: {

                    message = `${this.cliente.municipio.nome} com comprovação de endereço`

                    break;
                }
                case this.enums.classificacao.PROVISORIO: {

                    message = `${this.cliente.municipio.nome} sem comprovação de endereço`

                    break;
                }
                case this.enums.classificacao.OUTRO_MUNICIPIO: {

                    message = 'outro município'

                    break;
                }
            }

            return `Este paciente reside em ${message}. Confirma o cadastro?`
        },
        handleSubclassificacaoChange() {

            this.model.periodoValidade.start = null
            this.model.periodoValidade.end = null
        },
    }
}
</script>